import { LeftArrowIcon, RightArrowIcon } from '..';

interface ArrowProps {
  variant: 'left' | 'right';
  onClick: () => void;
}

const Arrow = ({ variant, onClick }: ArrowProps) => {
  const Icon = variant === 'left' ? LeftArrowIcon : RightArrowIcon;
  const handleClick = () => {
    onClick();
  };
  return (
    <button
      aria-label={variant}
      className="flex h-[5.8rem] min-h-[1.6rem] w-[5.8rem] min-w-[1.6rem] cursor-pointer items-center justify-center rounded-full border-4 border-white bg-brand-secondary p-[1.2rem] text-brand-white transition-all hover:bg-brand-primary"
      onClick={handleClick}
    >
      <Icon />
    </button>
  );
};

export default Arrow;
